// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1EGJS","errors":"Errors_errors__1Su13"};